/* Rugshaus · Kollektionsfilter (Okt 2026)
   Filtert ohne Neuladen über die Section Rendering API. */
(function () {
  if (window.__rhFiltersInit) return;
  window.__rhFiltersInit = true;

  var root = document.getElementById('RhColl');
  if (!root) return;

  var sectionId = root.getAttribute('data-section');
  var html = document.documentElement;
  var ctrl = null;
  var timer = null;
  var lastFocus = null;
  var mq = window.matchMedia('(max-width: 989px)');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var firstSort = $('[data-rh-sort]');
  var defaultSort = (firstSort && !new URLSearchParams(window.location.search).has('sort_by')) ? firstSort.value : null;

  /* Klebender Header (Atna fixiert ihn beim Scrollen) → Leiste/Seitenleiste kleben darunter */
  var hdr = $('.section--header');
  var lastTop = -1;
  function setStickyTop() {
    var top = 0;
    if (hdr) {
      var cs = getComputedStyle(hdr);
      if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
    }
    if (!mq.matches) top += 24;
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--rh-sticky-top', top + 'px'); }
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; setStickyTop(); });
  }, { passive: true });
  window.addEventListener('resize', setStickyTop, { passive: true });

  function queryFromForm() {
    var form = $('#RhFilterForm');
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (v, k) {
        if (v === '' || v == null) return;
        params.append(k, v);
      });
    }
    var sort = $('[data-rh-sort]');
    if (sort && !params.has('sort_by') && sort.value) params.set('sort_by', sort.value);
    if (defaultSort && params.get('sort_by') === defaultSort) params.delete('sort_by');
    return params.toString();
  }

  function openState() {
    var open = {};
    $all('#RhFltGroups details').forEach(function (d) { open[d.id] = d.open; });
    var sizes = $('#RhFltGroups .rh-sizes');
    return { open: open, sizesExpanded: !!(sizes && sizes.classList.contains('is-expanded')) };
  }

  function restoreState(st) {
    $all('#RhFltGroups details').forEach(function (d) {
      if (Object.prototype.hasOwnProperty.call(st.open, d.id)) d.open = st.open[d.id] || !!d.querySelector('.rh-flt__badge');
    });
    if (st.sizesExpanded) {
      var s = $('#RhFltGroups .rh-sizes');
      var b = $('#RhFltGroups [data-more]');
      if (s) s.classList.add('is-expanded');
      if (b) swapMore(b, true);
    }
  }

  function render(query, push) {
    var base = root.getAttribute('data-url') || window.location.pathname;
    var url = base + (query ? '?' + query : '');
    var fetchUrl = base + '?' + (query ? query + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);
    if (ctrl) ctrl.abort();
    ctrl = 'AbortController' in window ? new AbortController() : null;
    root.classList.add('is-loading');
    var st = openState();
    var scroller = mq.matches ? $('#RhFilterForm') : $('#RhFilters');
    var scrollTop = scroller ? scroller.scrollTop : 0;

    fetch(fetchUrl, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        ['#RhFltGroups', '#RhResults'].forEach(function (sel) {
          var fresh = $(sel, doc), cur = $(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        ['#RhFltApply', '#RhFltReset'].forEach(function (sel) {
          var fresh = $(sel, doc), cur = $(sel);
          if (fresh && cur) {
            cur.innerHTML = fresh.innerHTML;
            if (fresh.hasAttribute('hidden')) cur.setAttribute('hidden', ''); else cur.removeAttribute('hidden');
            if (fresh.getAttribute('href')) cur.setAttribute('href', fresh.getAttribute('href'));
          }
        });
        restoreState(st);
        if (scroller) scroller.scrollTop = scrollTop;
        if (html.classList.contains('rh-flt-open')) $all('[data-rh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        if (push) history.pushState({ rh: query }, '', url);
        else history.replaceState({ rh: query }, '', url);
        root.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('rh:filters:updated'));
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { render(queryFromForm(), true); }, delay);
  }

  function swapMore(btn, expanded) {
    if (!btn.getAttribute('data-more-label')) btn.setAttribute('data-more-label', btn.textContent);
    btn.textContent = expanded ? btn.getAttribute('data-less-label') : btn.getAttribute('data-more-label');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function scrollToResults() {
    if (mq.matches) return;
    var main = $('#RhResults');
    if (!main) return;
    var top = main.getBoundingClientRect().top + window.pageYOffset - (lastTop > 0 ? lastTop : 0);
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-rh-sort]')) { render(queryFromForm(), true); return; }
    if (t.matches('[data-price]')) { schedule(50); return; }
    if (t.closest('#RhFilterForm')) {
      var lbl = t.closest('.rh-size');
      if (lbl) lbl.classList.toggle('is-active', t.checked);
      schedule(150);
    }
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-price]')) schedule(900);
  });

  root.addEventListener('submit', function (e) {
    if (e.target.id === 'RhFilterForm') { e.preventDefault(); render(queryFromForm(), true); }
  });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-rh-link], #RhResults .pagination a');
    if (a && a.href && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      var u = new URL(a.href, window.location.origin);
      var isPage = !!a.closest('.pagination');
      render(u.searchParams.toString(), true);
      if (isPage) {
        var m = $('#RhResults');
        if (m) window.scrollTo({ top: m.getBoundingClientRect().top + window.pageYOffset - (lastTop > 0 ? lastTop : 0) - 8, behavior: 'smooth' });
      } else scrollToResults();
      return;
    }
    var more = e.target.closest('[data-more]');
    if (more) {
      var list = more.parentNode.querySelector('[data-more-list]');
      if (list) { var ex = list.classList.toggle('is-expanded'); swapMore(more, ex); }
      return;
    }
    var q = e.target.closest('[data-price-max]');
    if (q) {
      var inputs = $all('#RhFltGroups [data-price]');
      if (inputs.length === 2) { inputs[0].value = ''; inputs[1].value = q.getAttribute('data-price-max'); }
      render(queryFromForm(), true);
      return;
    }
    if (e.target.closest('[data-rh-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-rh-close]')) { closeDrawer(); return; }
  });

  /* ---------- Bottom-Sheet (mobil) ---------- */
  function openDrawer() {
    var panel = $('#RhFilters');
    if (!panel) return;
    lastFocus = document.activeElement;
    var scrim = $('.rh-flt__scrim');
    if (scrim) { scrim.removeAttribute('hidden'); scrim.style.display = 'block'; }
    requestAnimationFrame(function () { html.classList.add('rh-flt-open', 'rh-flt-lock'); });
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    $all('[data-rh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var c = $('.rh-flt__close'); if (c) c.focus({ preventScroll: true }); }, 80);
  }
  function closeDrawer() {
    if (!html.classList.contains('rh-flt-open')) return;
    html.classList.remove('rh-flt-open', 'rh-flt-lock');
    var panel = $('#RhFilters');
    if (panel) { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); }
    $all('[data-rh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { var s = $('.rh-flt__scrim'); if (s && !html.classList.contains('rh-flt-open')) { s.setAttribute('hidden', ''); s.style.display = ''; } }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (mq.addEventListener) mq.addEventListener('change', function () { closeDrawer(); setStickyTop(); });

  /* Wischen nach unten am Kopf schließt das Sheet */
  (function () {
    var y0 = null;
    root.addEventListener('touchstart', function (e) { if (e.target.closest('.rh-flt__head')) y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 60) closeDrawer(); y0 = null; }, { passive: true });
  })();

  window.addEventListener('popstate', function () {
    render(window.location.search.replace(/^\?/, ''), false);
  });

  setStickyTop();
})();
